
const setDefaults = (properties) => {
    if (properties.audioLayer === undefined) {
        properties.audioLayer = "10"
    }
    if (properties.areaDisplayStyle === undefined) {
        properties.areaDisplayStyle = "area"
    }
    if (properties.audioPlayerVisible === undefined) {
        properties.audioPlayerVisible = "true"
    }
    if (properties.audioLoop === undefined) {
        properties.audioLoop = "false"
    }
    if (properties.audioPlayUntilEnd === undefined) {
        properties.audioPlayUntilEnd = "false"
    }
    if (properties.audioContinueOnReEntry === undefined) {
        properties.audioContinueOnReEntry = "true"
    }
    return properties;
}

const checkHotspotType = (popupData) => {
    let selected;
    if (popupData.areaDisplayStyle === "area"
        && (popupData.audioLayer === "10" || popupData.audioLayer === 10)
        && (popupData.audioPlayerVisible === "true" || popupData.audioPlayerVisible === true)
        && (popupData.audioLoop === "false" || popupData.audioLoop === false)
        && (popupData.audioPlayUntilEnd === "false" || popupData.audioPlayUntilEnd === false)
        && (popupData.audioContinueOnReEntry === "true" || popupData.audioContinueOnReEntry === true || popupData.audioContinueOnReEntry === undefined)) {
        selected = "standard";

    } else if (popupData.areaDisplayStyle === "none"
        && (popupData.audioLayer === "3" || popupData.audioLayer === 3)
        && (popupData.audioPlayerVisible === "false" || popupData.audioPlayerVisible === false)
        && (popupData.audioLoop === "true" || popupData.audioLoop === true)
        && (popupData.audioPlayUntilEnd === "false" || popupData.audioPlayUntilEnd === false)
        && (popupData.audioContinueOnReEntry === "true" || popupData.audioContinueOnReEntry === true || popupData.audioContinueOnReEntry === undefined)) {
        selected = "background";

    } else if (popupData.areaDisplayStyle === "none"
        && (popupData.audioLayer === "5" || popupData.audioLayer === 5)
        && (popupData.audioPlayerVisible === "false" || popupData.audioPlayerVisible === false)
        && (popupData.audioLoop === "false" || popupData.audioLoop === false)
        && (popupData.audioPlayUntilEnd === "true" || popupData.audioPlayUntilEnd === true)
        && (popupData.audioContinueOnReEntry === "true" || popupData.audioContinueOnReEntry === true || popupData.audioContinueOnReEntry === undefined)) {
        selected = "instructional";

    } else {
        selected = "custom";
    }
    return selected;
}


export { checkHotspotType, setDefaults }